
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-ex-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-ex-outline"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('circle',{staticClass:"cog-i-ex-outline__circle",attrs:{"cx":"9","cy":"9","r":"6.15","stroke-miterlimit":"10"}}),_c('g',{staticClass:"cog-i-ex-outline__ex"},[_c('path',{attrs:{"d":"M6.54 6.54l4.92 4.92M11.46 6.54l-4.92 4.92"}})])])])
          )
        }
      }
    